import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import PublicPage from './pages/PublicPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/:slug" element={<PublicPage />} />
        <Route path="*" element={<PublicPage />} />
      </Routes>
    </BrowserRouter>
  );
}
